// extracted by mini-css-extract-plugin
module.exports = {"root":"ShareModal_root__2WIyP","poster":"ShareModal_poster__3g4u5"};